"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tab = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _deepExtend = _interopRequireDefault(require("deep-extend"));

var Container = _styledComponents["default"].div.withConfig({
  displayName: "styled__Container",
  componentId: "sc-14dcm3j-0"
})(function (_ref) {
  var _theme$tabList;

  var theme = _ref.theme;
  return (0, _deepExtend["default"])({
    display: "flex",
    height: "41px",
    background: "#f7f6f9"
  }, theme === null || theme === void 0 ? void 0 : (_theme$tabList = theme.tabList) === null || _theme$tabList === void 0 ? void 0 : _theme$tabList.container);
});

exports.Container = Container;

var Tab = _styledComponents["default"].button.withConfig({
  displayName: "styled__Tab",
  componentId: "sc-14dcm3j-1"
})(function (_ref2) {
  var _theme$brand$colors$p, _theme$brand, _theme$brand$colors, _theme$brand$colors$p2, _theme$brand2, _theme$brand2$colors, _theme$tabList2;

  var theme = _ref2.theme;
  return (0, _deepExtend["default"])({
    backgroundColor: "#F9FAFB",
    color: "#73819b",
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "14px",
    fontStyle: "normal",
    lineHeight: "19px",
    letterSpacing: "0em",
    fontWeight: 400,
    textAlign: "center",
    cursor: "pointer",
    border: "1px solid rgba(203, 213, 224, 0.2)",
    borderTop: "1px solid rgba(203, 213, 224, 0.5)",
    borderBottom: "2px solid transparent",
    "&.active": {
      color: (_theme$brand$colors$p = theme === null || theme === void 0 ? void 0 : (_theme$brand = theme.brand) === null || _theme$brand === void 0 ? void 0 : (_theme$brand$colors = _theme$brand.colors) === null || _theme$brand$colors === void 0 ? void 0 : _theme$brand$colors.primary) !== null && _theme$brand$colors$p !== void 0 ? _theme$brand$colors$p : "#9121c2",
      fontWeight: "600",
      borderBottom: "2px solid ".concat((_theme$brand$colors$p2 = theme === null || theme === void 0 ? void 0 : (_theme$brand2 = theme.brand) === null || _theme$brand2 === void 0 ? void 0 : (_theme$brand2$colors = _theme$brand2.colors) === null || _theme$brand2$colors === void 0 ? void 0 : _theme$brand2$colors.primary) !== null && _theme$brand$colors$p2 !== void 0 ? _theme$brand$colors$p2 : "#9121c2")
    }
  }, theme === null || theme === void 0 ? void 0 : (_theme$tabList2 = theme.tabList) === null || _theme$tabList2 === void 0 ? void 0 : _theme$tabList2.tab);
});

exports.Tab = Tab;